import { Icon } from '@silverfort/sf-components';
import React from 'react';


export interface InsightColumnProps {
    title: string;
    isBlurred: boolean | undefined;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
}
const InsightColumn = ({ icon, title, isBlurred }: InsightColumnProps) => {
    return (
        <div className={`flex h-full w-full items-center ${isBlurred ? 'opacity-20' : ''}`}>
            <div className="flex flex-1 gap-2 px-2 items-center">
                <Icon icon={icon} size={16} />
                <span className="text-13 text-sf">{title}</span>
            </div>
        </div>
    );
};

export default InsightColumn;
